        //xeditable options

export const xEditableConfig = ['editableOptions', 'editableThemes', (editableOptions, editableThemes) => {
    editableOptions.theme = 'bs3';
    editableThemes.bs3.errorTpl = '';
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm';
}];